const encoder = new TextEncoder()

function toBase64(bytes: Uint8Array) {
  let binary = ''
  bytes.forEach((byte) => { binary += String.fromCharCode(byte) })
  return btoa(binary)
}

export function createSalt() { return toBase64(crypto.getRandomValues(new Uint8Array(16))) }

export async function hashPassword(password: string, salt: string) {
  const material = await crypto.subtle.importKey('raw', encoder.encode(password), 'PBKDF2', false, ['deriveBits'])
  const derived = await crypto.subtle.deriveBits({ name: 'PBKDF2', hash: 'SHA-256', iterations: 210_000, salt: encoder.encode(salt) }, material, 256)
  return toBase64(new Uint8Array(derived))
}
